import { render, staticRenderFns } from "./ContactUsData.vue?vue&type=template&id=52629f07&"
import script from "./ContactUsData.vue?vue&type=script&lang=js&"
export * from "./ContactUsData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports